import { $http } from './http.js';
/*
  定义请求接口方式:
  get: 使用params参数定义query
  post: 使用data参数定义报文体
  put: 使用params作为query, data作为报文体
  delete: 使用params作为query
*/
/* eslint-disable */
const _get = { type: 'get' };
const _post = { type: 'post' };

const _fatch = (config = {}) => {
  if (config.type === 'post') {
    return (data = {}) => $http({data, ...config}).post();
  }
  return (params = {}) => $http({params, ...config}).get();
};
// 接口配置
export const api = {
  userLogin: {
    url: 'auth/token', isAllData: true, ..._post, isNoPermission: true
  },
  addUser: {url: 'user/userInsert', ..._post},
  setUserRole: {url: 'userRelation/updateRelation', ..._post, isJson: true},
  editUser: {url: 'user/userUpdate', ..._post},
  delUser: {url: 'user/userDelete', ..._post},
  getUserBy: {url: 'user/userQueryById', ..._post},
  getUserList: {url: 'user/userQueryByList', ..._post},
  getMenu: {url: 'auth/getPermission', ..._post},
  // 权限显示按钮
  getBtnLimit: {url: 'permission/getBtnLimit', ..._post},
  getRoleList: {url: 'role/roleQueryByList', ..._post},
  delRoleById: {url: 'role/roleDelete', ..._post},
  delSignUpById: {url: 'meetingSignUpRecord/remove', ..._post},
  delMeetingById: {url: 'meeting/remove', ..._post},
  addRole: {url: 'role/roleInsert', ..._post},
  editRole: {url: 'role/roleUpdate', ..._post},
  getRoleById: {url: 'permission/getRolePermission', ..._post},
  getResourseList: {url: 'permission/permissionTree', ..._post},
  addPermission: {url: 'permission/permissionInsert', ..._post},
  updatePermission: {url: 'permission/permissionUpdate', ..._post},
  setPermission: {url: 'permissionRelation/updateRelation', ..._post, isJson: true},
  // 确认收货
  confirmgoods:{url:'order/updateOrderById', ..._post},
  // 用户管理列表
  queryMember: {url: 'user/userQueryList', ..._post},
  // 下级用户列表
  exportRecommendList: {url: 'exports/exportRecommendList', ..._post},
  // 成为合伙人
  operatePartner: {url: 'user/operatePartner', ..._post},
  // 修改确认时间
  operatePartnerTypeUpdateTime: {url: 'user/operatePartnerTypeUpdateTime', ..._post},
  // 调整 是否购机
  saveUserIsUnderLinePay : {url: 'user/saveUserIsUnderLinePay', ..._post},
  // 调整 可确认收款人数
  updateBranchConfirmReceiptNumber : {url: 'user/updateBranchConfirmReceiptNumber', ..._post},
  // 成为合伙人
  saveRecruitFreeze: {url: 'user/saveRecruitFreeze', ..._post},
  // 成为合伙人
  switchBranchConfirmReceipt: {url: 'user/switchBranchConfirmReceipt', ..._post},
  // 用户管理积分列表
  queryMemberJiFen: {url: 'user/userQueryListNew', ..._post},
  // 修改用户状态
  updateZpUser: {url: 'user/updateZpUser', ..._post},
  //删除用户
  userRemove:{url:'user/userRemove',..._post},
  // 用户信息变更记录
  userInfoChangeLogList: {url: 'user/userInfoChangeLogList', ..._post},
  // 后台重置用户手机号（无需短信验证码）
  resetUserPhone: {url: 'user/resetUserPhone', ..._post},
  // 线上水机
  OnLineSaleDetail: {url: 'exports/exportOnLineSaleDetail', ..._post},
  // 确认收货
  confirmgoods:{url:'order/updateOrderById', ..._post},
  // 区域水机
  AreaBranchSale: {url: 'exports/exportAreaBranchSaleInfo', ..._post},
  // 积分增减
  jiFenDetails: {url: 'exports/jiFenDetailsForAreaAndPerson', ..._post},
  // 查询下级人员列表
  queryChild: {url: 'user/userQueryByParentId', ..._post},
  // 水机列表
  queryWater: {url: 'zpshopcommodity/commodityByPage', ..._post},
  // 判断用户权限是否开启
  IsAdminById: {url: 'user/userIsAdminById', ..._post},
  // 水机类型列表
  queryWaterType: {url: 'zpshopcommodity/commodityTypeByPage', ..._post},
  // 查询所有水机类型
  queryAllWaterType: {url: 'zpshopcommodity/allCommodityType', ..._post},
  // 线下结款
  UnderLinePay: {url: 'userWithdraw/updateWithdrawStatusUnderLinePay', ..._post},
  // 创建水机类型
  createWaterType: {url: 'zpshopcommodity/createShopType', ..._post},
  // t推荐人下级列表
  exportRecommend: {url: 'exports/exportRecommend', ..._post},
  // 修改水机类型
  updateWaterType: {url: 'zpshopcommodity/updateShopType', ..._post},
  // 删除水机类型
  delWaterType: {url: 'zpshopcommodity/deleteShopType', ..._post},
  // 水机版本号
  queryZpShopCode: {url: 'zpshopcode/queryZpShopCode', ..._post},
  // 修改水机版本号
  updateZpShopCode: {url: 'zpshopcode/updateZpShopCode', ..._post},
  // 创建水机
  createWater: {url: 'zpshopcommodity/createShopCommodity', ..._post},
  // 订单列表
  queryOrderList: {url: 'order/orderQueryByList', ..._post},
  // 查询支付通道
  queryPaymentChannel: {url: 'order/paymentChannel/query', ..._post},
  savePaymentChannel: {url:  'order/paymentChannel/save', ..._post},
  // 查询支付通道
  querywithdrawChannel: {url: 'userWithdraw/withdrawChannel/query', ..._post},
  savewithdrawChannel: {url:  'userWithdraw/withdrawChannel/save', ..._post},
  // 订单详情
  selectOrderList: {url: 'order/selectOrderList', ..._post},
  // 图片上传
  upload: {url: 'file/upload', ..._post},
  // 图片上传
  uploadByOne: {url: 'file/uploadByOne', ..._post},
  // 收益列表
  queryIncomeList: {url: 'zpuserincome/incomeByPage', ..._post},
  // 审核列表
  queryWithdrawList: {url: 'userWithdraw/withdrawQueryByList', ..._post},
  // 提现审核
  // url: 'userWithdraw/updateWithdrawStatus'
  changeWithdrawStatus: {url: 'userWithdraw/updateWithdrawStatus', ..._post},
  // 提现审核单
  changeWithdrawStatusdan: {url: 'userWithdraw/updateWithdrawStatusByOne', ..._post},
  // 提现审核信息
  queryWithdrawListX: {url: 'userWithdraw/getWithdraw', ..._post},
  // 修改审核信息
  updateWithdrawList: {url: 'userWithdraw/updateWithdraw', ..._post},
  // 提现记录列表
  queryWithdrawLog: {url: 'userWithdraw/recordQueryByList', ..._post},
  // 分公司列表
  queryBranch: {url: 'branch/branchQueryByList', ..._post},
  // 公司审核 修改分公司状态
  updateBranch: {url: 'branch/updateBranch', ..._post},
  // 公司审核 修改分公司状态
  updateBranchAudioTime: {url: 'branch/updateBranchAudioTime', ..._post},
  // 代理商冻结
  updateBranchByFrozen: {url: 'branch/updateBranchByFrozen', ..._post},
  // 查询公司员工
  querychannelPersons: {url: 'channel/findById', ..._post},
  querychannelPerson: {url: 'channel/editChannelInfoBefore', ..._post},
  querytouzishangPerson: {url: 'tzs/editTzsInfoBefore', ..._post},
  // 修改区域商审核状态
  updateChannelState: {url: 'channel/updateChannelState', ..._post},
  // 修改区域商状态
  updateStatus: {url: 'channel/updateStatus', ..._post},
  // 查看区域商详情
  queryBranchPerson: {url: 'branch/personQueryByBranchId', ..._post},
  // 增加区域商
  queryAddchannelPerson: {url: 'channel/insertChannel', ..._post},
  // 投资商类型列表
  queryInvestorType: {url: 'adType/advertiserTypeList', ..._post},
  // 投资商类型详情
  queryInvestorTypedetile: {url: 'adType/getAdvertiserTypeById', ..._post},
  // 投资商类型添加
  queryInvestorTypeadd: {url: 'adType/addAdvertiserType', ..._post},
  // 投资商类型修改
  queryInvestorTypeupdate: {url: 'adType/updateAdvertiserType', ..._post},
  // 投资商列表
  queryInvestorlist: {url: 'tzs/userQueryByList', ..._post},
  // 所属业务员
  querytzscssalemans: {url: 'tzs/tzscssalemans', ..._post},
  // 裂变用户详情
  getUserCommodity: {url: 'salesman/getUserCommodityByPage', ..._post},
  // 业务统计月报
  getPresentationList: {url: 'presentation/getPresentationListByPage', ..._post},
  // 选择业务员
  savePresentation: {url: 'presentation/savePresentation', ..._post},
  // 业务员修改密码
  updateSalesmanPassword: {url: 'salesman/updateSalesmanPassword', ..._post},
  // 广告投资商收益管理
  incomeByPage: {url: 'zpuserincome/incomeByPage', ..._post},
  // 开启双账户
  getByECode: {url: 'dict/getByECode', ..._post},
  // 回显开关
  getByECodeThree: {url: 'dict/getByECodeThree', ..._post},
  // 修改双账户
  editByECode: {url: 'dict/editByECode', ..._post},
  // 发送发票
  updateInvoiceStatusById: {url: 'order/updateInvoiceStatusById', ..._post},
  // 转入小账
  zhaunruxiaozhang: {url: 'zjAggregatePayment/jiesuan', ..._get},
  // 导出裂变收益
  exportAdvertisingInvestor: {url: 'exports/exportAdvertisingInvestorIncome', ..._post},
  // 业务统计月报查看详细
  getPresentationCommodityList: {url: 'presentation/getPresentationCommodityListByPage', ..._post},
  // 投资商列表添加
  queryInvestoradd: {url: 'tzs/insertTzs', ..._post},
  // 投资商用户列表查询
  queryInvestoruserlist: {url: 'branchUser/branchUserQueryList', ..._post},
  // 积分校对列表查询
  getListByPageList: {url: 'proofreading/getListByPage', ..._post},
  // 积分校对处理
  handleProofreading: {url: 'proofreading/handleProofreading', ..._post},
  // 投资商用户移除
  queryInvestoruserzhuanyi: {url: 'branchUser/zhuanyi', ..._post},
  // 投资商用户移除操作
  queryInvestoruserupdatez: {url: 'branchUser/updatetodailisheng', ..._post},
// 投资商用户报修操作
  updatarepair: {url: 'branchUser/updatarepair', ..._post},
  // 投资商列表冻结运行
  queryInvestorshenhe: {url: 'tzs/updateStatusByFrozen', ..._post},
  // 投资商列表详情
  Investordetil: {url: 'tzs/findById', ..._post},
  // 业务员管理列表
  querysalesman: {url: 'salesman/getSalesmanListByPage', ..._post},
  //业务员管理详情
  querysalesmandetile: {url: 'salesman/getSalesmanById', ..._post},
  //添加业务员管理
  querysalesmanadd: {url: 'salesman/insertSalesman', ..._post},
  //业务员冻结运行
  salesmanDelete: {url: 'salesman/salesmanDelete', ..._post},
  //广告投资商列表
  querysalesmanlistz: {url: 'salesman/getAddvertisingInvestorList', ..._post},
  //修改业务员管理
  querysalesmanmodify: {url: 'salesman/updateSalesman', ..._post},
  //请求投资商参数
  tzskindcs: {url: 'tzs/tzskindcs', ..._post},
  // 类型管理删除
  deltype: {url: 'adType/delAdvertiserType', ..._post},
  // 管理和创建分公司
  createOrUpdateBranch: {url: 'branch/createOrUpdateBranch', ..._post},
  // 水机购买详情
  orderQueryById: {url: 'order/orderQueryById', ..._post},
  // 查询开户行
  getBankList: {url: 'user/getBankList', ..._post},
  // 查询分公司详情和人员
  queryBranchDetail: {url: 'branch/queryBranchDetail', ..._post},
  // 查看积分详情
  queryIntegralLogList: {url: 'user/userIntegralLogList', ..._post},
  // 查看税率列表
  querydictQueryByList: {url: 'dict/dictQueryByList', ..._post},
  // 修改密码
  userUpdate: {url: 'user/changePassword', ..._post},
  // 修改税率列表
  updateDictionaries: {url: 'dict/updateDictionariesById', ..._post},
  // 查询日志列表
  OperationRecordPage: {url: 'record/getOperationRecordPage', ..._post},
  // 区域商列表
  querDdistributors:{url:'channel/channelQueryByList',..._post},
  // 获取地址
  queryAddress: {url: 'zplocation/findByType', ..._post},
  // 查询用户
  getUser: {url: 'user/getZpUser', ..._post},
  // 查询身份列表
  getPostionList: {url: 'branch/queryBranchLevelList', ..._post},
  // 获取身份详情
  getPostion: {url: 'branch/getBranchLevel', ..._post},
  // 获取投诉列表
  getComplaintPage: {url: 'complaint/getComplaintPage', ..._post},
  // 获取投诉详情
  getComplaintContent: {url: 'complaint/getComplaintContent', ..._post},
  // 删除投诉列表
  delComplaint: {url: 'complaint/delComplaint', ..._post},
  // 修改身份级别
  updatePosition: {url: 'branch/updateBranchLevel', ..._post},
  // 修改区域商身份
  updatechannelPosition: {url: 'channel/updateStatus', ..._post},
  // 区域商冻结
  updateStatusByFrozen: {url: 'channel/updateStatusByFrozen', ..._post},
  // 积分管理列表
  BalanceManagerList: {url: 'branch/companyAccountBalanceManagerListPage', ..._post},
  // 查看余额详情
  AccountBalanceList: {url: 'branch/getCompanyAccountBalanceListPage', ..._post},
  // 修改余额
  updateCompanyAccount: {url: 'branch/updateCompanyAccountBalance', ..._post},
  // 回显余额
  CompanyDetail: {url: 'branch/getCompanyDetailById', ..._post},
  // 余额管理列表
  getIntegral: {url: 'user/userQueryListNew', ..._post},
  // 修改用户积分
  updateIntegral: {url: 'user/updateZpUser', ..._post},
  // 批量下载二维码
  downloadQrcode: {url: 'zpshopcommodity/download',responseType: 'arraybuffer', isAllData: true, isNoPermission: true, ..._post},
  // 水机发货列表
  querySendList: {url: 'order/selectOrderDetails', ..._post},
  // 查询全部水机
  queryAllCommodity: {url: 'zpshopcommodity/selectAllCommodity', ..._post},
  // 绑定水机订单
  bindingCommodity: {url: 'zpshopcommodity/bindingCommodity', ..._post},
  // 修改水机信息
  updateShopCommodity: {url: 'zpshopcommodity/updateShopCommodity', ..._post},
  // 根据订单号修改状态
  updateStatusById: {url: 'order/updateStatusById', ..._post},
  // 复核列表
  getPartnerList: {url: 'partner/getPartnerPriceListByPage', ..._post},
  // 复核操作
  // partner/updatePartnerState
  checkPartnerState: {url: 'partner/updatePartnerState', ..._post},
  checkPartnerStatedan: {url: 'partner/updatePartnerStateByOne', ..._post},
  backPartnerToAudio: {url: 'partner/backPartnerToAudio', ..._post},
  backWithdrawToAudio: {url: 'userWithdraw/backWithdrawToAudio', ..._post},
  // 查询复核数据
  getZpPartnerById: {url: 'partner/getZpPartnerById', ..._post},
  // 更新复核数据
  updatePartner: {url: 'partner/updatePartnerById', ..._post},
  // 查看分公司收益列表
  integraldetail: {url: 'branch/companyIntegralDetailListPage', ..._post},
  // 查看分公司详情
  companydetailL: {url: 'branch/getCompanyDetailLogInfo', ..._post},
  // 查看修改数据
  getCompanyDetail: {url: 'branch/updateCompanyInfoBefore', ..._post},
  // 修改积分数据
  updateCompany: {url: 'branch/updateCompanyInfo', ..._post},
  // 积分导出
  exportCompany: {url: 'exports/exportCompanyIncome', ..._post},
  // 查询好产品列表
  selectMemberRateInfo: {url: 'branch/selectMemberRateInfo', ..._post},
  // 修改好产品列表
  updateMemberRateInfo: {url: 'branch/updateMemberRateInfo', ..._post},
  // 好产品导出
  exportGoods: {url: 'exports/exportGoodsShopReward', ..._post},
  //  公司提现记录表
  exportWithdraw: {url: 'exports/exportWithdraw', ..._post},
  // 个人提现记录表
  exportPeopleWithdraw: {url: 'exports/exportPeopleWithdraw', ..._post},
  // 个人积分修改
  updateUserInteger: {url: 'user/updateUserInteger', ..._post},
  // 商品销售记录表
  exportShopBuyLog: {url: 'exports/exportShopBuyLog', ..._post},
  // 修改推荐人身份
  changeReferee: {url: 'referee/changeReferee', ..._post},
  // 查询区域商默认分润金额
  getProfitByQds: {url: 'channel/getProfitByQds', ..._post},
  // 查询区域招募信息
  locationList: {url: 'zplocation/findByPage', ..._post},
  // 查询区域招募信息
  provinceList: {url: 'zplocation/findByPageProvince', ..._post},
  // 查询区域招募信息
  cityList: {url: 'zplocation/findByPageCity', ..._post},
  // 修改区域招募信息
  locationUpdate: {url: 'zplocation/update', ..._post},
  // 修改区域招募信息
  locationSave: {url: 'zplocation/save', ..._post},
  // 修改区域招募信息
  provinceUpdate: {url: 'zplocation/updateProvince', ..._post},
  // 删除区域
  delLocationById: {url: 'zplocation/delete', ..._post},
  // 查询会议列表
  orderQueryByList: {url: 'meeting/orderQueryByList', ..._post},
  // 保存和修改会议
  saveOrUpdate: {url: 'meeting/saveOrUpdate', ..._post},
  // 回显地址
  selectLocation: { url: 'zplocation/findByAll', ..._post },
  // 获取一封家书
  getLetter: { url: 'letter/findLetter', ..._post },
  // 获取协议
  getProtocol: { url: 'letter/findProtocol', ..._post },
  // 修改一封家书
  updateLetter: { url: 'letter/save', ..._post },
  // 修改一封家书
  updateProtocol: { url: 'letter/save2', ..._post },

  // 修改会议报名报告
  updateMeetingSignUpRecord: { url: 'meetingSignUpRecord/update', ..._post },
  // 查询会议报名报告
  selectMeetingSignUpRecord: { url: 'meetingSignUpRecord/meetingSignUpRecordQueryByList', ..._post },
  // 导出会议报名信息列表
  exportMeetingReport: { url: 'exports/exportMeetingReport', ..._get },
};

let data = {};
// 初始化请求方法
let config = {};
for (let item in api) {
  config = api[item];
  data[item] = _fatch(config);
}

/* 注册vue原型 */
export const install = Vue => {
  Vue.prototype.$fatch = data;
  Vue.prototype.$api = api;
};

export default data;



// WEBPACK FOOTER //
// ./src/utils/fatch.js